import { DoqType } from '@ardoq/doq';
import { NoReferencesOrListFieldsDoq } from 'tabview/graphViews/emptyStates/NoReferencesOrListFieldsDoq';
import { NoDataAvailableDoq } from 'tabview/graphViews/emptyStates/NoDataAvailableDoq';
import { NoDataWithFiltersDoq } from 'tabview/graphViews/emptyStates/NoDataWithFiltersDoq';
import { NoDataWithShowEmptyValuesDoq } from 'tabview/graphViews/emptyStates/NoDataWithShowEmptyValuesDoq';
import { ViewIds } from '@ardoq/api-types';
import { connect } from '@ardoq/rxbeach';
import { emptyView$ } from 'views/streams/emptyView$';

type EmptyState2Props = {
  noVisibleComponents: boolean;
  noReferencesOrListFields: boolean;
  hasActiveFilter: boolean;
  allDescendantsIncluded: boolean;
  hasFilteredNullItems: boolean;
  isPresentationMode: boolean;
  isWorkspaceEmpty: boolean;
};

const VIEW_ID = ViewIds.COMPONENT_MATRIX_2;

const EmptyState2Base = ({
  noVisibleComponents,
  hasActiveFilter,
  allDescendantsIncluded,
  noReferencesOrListFields,
  hasFilteredNullItems,
  isPresentationMode,
  isWorkspaceEmpty,
}: EmptyState2Props) => {
  if (isWorkspaceEmpty) {
    return (
      <NoDataAvailableDoq
        doqType={DoqType.COMPONENT_MATRIX_ERROR}
        includeActions={!isPresentationMode}
      />
    );
  }

  if ((hasActiveFilter || !allDescendantsIncluded) && noVisibleComponents) {
    return (
      <NoDataWithFiltersDoq
        doqType={DoqType.COMPONENT_MATRIX_ERROR}
        includeActions={false}
        canApplyIncludeAllDescendantsFilter
      />
    );
  }

  if (hasFilteredNullItems && noVisibleComponents) {
    return (
      <NoDataWithShowEmptyValuesDoq
        viewId={VIEW_ID}
        doqType={DoqType.COMPONENT_MATRIX_ERROR}
      />
    );
  }

  if (noReferencesOrListFields) {
    return (
      <NoReferencesOrListFieldsDoq doqType={DoqType.COMPONENT_MATRIX_ERROR} />
    );
  }

  return null;
};

export const EmptyState2 = connect(EmptyState2Base, emptyView$);
